import { Badge } from "@/components/ui/badge";
import {
  enrichmentStatusClasses,
  enrichmentStatusLabel,
} from "@/lib/enrichment";
import { cn } from "@/lib/utils";

/**
 * Colored badge for an entity's `enrichmentStatus`, shared by the resource list
 * columns and show pages so the cinema verticals read the enrichment lifecycle
 * the same way everywhere. Renders nothing for an empty status.
 *
 * Label and colour both come from `@/lib/enrichment`, which is also where the
 * column filter's options come from. It used to spell the label inline —
 * `status === "InProgress" ? "In progress" : status` — so the dropdown offered
 * "Needs Review" and every matching cell said `NeedsReview`, on all nine entity
 * lists at once. The option list and the badge cannot drift while they share
 * one function.
 */
export function EnrichmentStatusBadge({
  status,
  className,
}: {
  status?: string | null;
  className?: string;
}) {
  if (!status) return null;
  return (
    <Badge
      variant="outline"
      className={cn(enrichmentStatusClasses(status), className)}
    >
      {enrichmentStatusLabel(status)}
    </Badge>
  );
}
